import React from 'react';

const CheckBox = props => {
  const { dymamicClass = '', onClick = function() {} } = props;
  return (
    <div className={`common-check-box ${dymamicClass}`} onClick={onClick}>
      <div className="common-check-box-content">
        <div className="empty-check-box" />
        <div className="common-check-box-svg-wrap">
          <svg width="16" height="14" viewBox="0 0 16 14">
            <path d="M2 8.5L6 12.5L14 1.5" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CheckBox;
export { CheckBox };
